import { ArrowPathIcon, CloudArrowUpIcon, FingerPrintIcon, LockClosedIcon, BanknotesIcon } from '@heroicons/react/24/outline'
import {
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
  } from "@material-tailwind/react";
  import React from 'react';



export default function HealthHeading() {
  return (
    <React.Fragment>
    <div className=" pt-24 text-ternary-dark dark:text-ternary-light  sm:pt-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600"></h2>
          <p className="mt-2 text-3xl font-bold tracking-tight  sm:text-4xl">
          Health Insurance          </p>
          <p className="mt-6 text-lg leading-8 ">
          Britam offers an array of health insurance solutions. Britam Milele Retail and Kinga Ya Mkulima cover individuals and families , while Britam Milele Corporate, offers a flexible inpatient cover and a fund- managed outpatient cover for employees and their dependants. Britam Milele Corporate is ideal for registered companies, NGOs, as well as Chamas with more than 10 members.          </p>
        </div>
        
      </div>
    </div>


</React.Fragment>
  )
}